import { Injectable, inject } from "@angular/core";
import { Ability, subject } from "@casl/ability";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { ProductService } from "src/app/services/product.service";
import { SoftwareProduct } from "src/app/support/product";

export type AbilityAction =
  | "read"
  | "update"
  | "create"
  | "delete"
  | "set-executors"
  | "set-execution-date"
  | "merge"
  | "set-drop-page"
  | "reject";

export type AbilitySubject =
  | "kpi"
  | "bot"
  | "job"
  | "ui-flowboard"
  | "health-record"
  | "book"
  | "document"
  | "invoice"
  | "template"
  | "drug"
  | "medical-service"
  | "work-order"
  | "product"
  | "reminder"
  | "physician"
  | "export"
  | "import"
  | "analytics"
  | "letterhead"
  | "role"
  | "member"
  | "bank-account"
  | "payment-method"
  | "rate-table"
  | "prescription"
  | "tag"
  | "room"
  | "group"
  | "quote"
  | "fiscal-profile"
  | "appointment"
  | "recovery"
  | "customer"
  | "patient"
  | "ticket"
  | "task"
  | "request"
  | "study"
  | "box"
  | "device"
  | "setting"
  | "attachment"
  | "schedule"
  | "open-book"
  | "file"
  | "notification"
  | "message"
  | "cart"
  | "worklist"
  | "report"
  | "business-unit"
  | "supplier"
  | "storage"
  | "movement"
  | "good"
  | "remuneration"
  | "payment"
  | "campaign"
  | "segmentation"
  | "survey"
  | "sending"
  | "installation"
  | "integration"
  | "command"
  | "packaging";

@Injectable()
export class UserService {
  private readonly bootstrapService = inject(BootstrapService);
  private readonly ability: Ability = inject(Ability);

  private readonly currentProduct = inject(ProductService).getCurrentProduct();

  able(
    action: AbilityAction,
    subjectName: AbilitySubject,
    conditions?: any
  ): boolean {
    switch (this.currentProduct) {
      case SoftwareProduct.BOTMASTER: {
        return this.ability.can(
          action,
          subject(subjectName, {
            accountId: this.bootstrapService.getCurrentMemberAuth()!.account,
            ...conditions
          })
        );
      }
      case "Rocket":
      default: {
        return conditions
          ? this.ability.can(
              action,
              subject(subjectName, {
                tenant: this.bootstrapService.getCurrentTenant()!.id,
                account: this.bootstrapService.getCurrentTenant()!.account,
                ...conditions
              })
            )
          : this.ability.can(action, subjectName);
      }
    }
  }

  unable(
    action: AbilityAction,
    subject: AbilitySubject,
    conditions?: any
  ): boolean {
    return !this.able(action, subject, conditions);
  }
}
